export default async ({ app }, locale) => {
  return await app.store.dispatch('global/fetchTranslations', { locale })
}
